module.exports = __webpack_public_path__ + "static/media/outlook.156b8a54.svg";